import React from 'react';
import { FieldError, FieldValues } from 'react-hook-form';
import { FaAsterisk } from 'react-icons/fa6';

interface FormInputProps {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  register: FieldValues;
  errors: FieldError | undefined;
  touchedField: boolean | undefined;
  required?: boolean | undefined;
  disabled?: boolean;
  //touchedFields: useFormStateReturn<FormData>['touchedFields']
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  type = 'text',
  placeholder,
  register,
  errors,
  touchedField: touchedFields,
  required,
  disabled,
}) => {
  return (
    <div className="w-full max-w-lg">
      <label className="block text-sm font-medium text-primary flex flex-row gap-2 items-center">
        {label} {required ? <FaAsterisk /> : ''}
      </label>
      {type === 'checkbox' ? (
        <input
          type="checkbox"
          className={`input toggle toggle-primary ${errors ? 'border-2 border-error' : ''}`}
          {...register}
        />
      ) : (
        <input
          type={type}
          placeholder={placeholder}
          {...register}
          disabled={disabled}
          className={`input w-full p-2 border-2 rounded border-base-200 ${
            errors ? 'border-2 border-error' : touchedFields ? 'border-2 border-success' : 'border-base-200'
          }`}
        />
      )}
      {errors && <p className="text-red-500 text-sm">{errors?.message}</p>}
    </div>
  );
};

export default FormInput;
